import {NavLink} from "react-router-dom"
import {publicUrlFor} from "../../../globals/constants"
import {Link} from "react-scroll";
import ContactPage from "../../components/misc/contact-us";
import {trackPhoneClick} from "../../../lib/gtag";
import {resetConsent} from "../../../lib/consent";
import {referral, slogan} from "../../../globals/data/home1";

export default function Footer1() {

  const today = new Date();
  const date = today.getFullYear();

  const handleClickPhone = (phone) => {
    trackPhoneClick('AW-17491861595/GmBFCJ-yi5AbENvA4pRB', phone);
  };

  return (
    <>
      <footer className="footer-dark p-t100" id={'quotation'}>

        {/* OFFER SECTION */}
        <div className="">

          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 col-xl-12">
                <ContactPage />
              </div>
            </div>
          </div>

        </div>
        {/* OFFER SECTION END */}

        {/* NEWS LETTER SECTION START */}
        <div className="ftr-nw-ltr site-bg-white pt-6">

          <div className="ftr-nw-ltr-inner site-bg-primary">
            <div className="container">
              {/* Balra a telefonszamok, kozepen a szoveg, jobbra a karakter.
                  A kep a DOM-ban utolso: asztali nezetben abszolut pozicional
                  (mindegy a sorrend), mobilon viszont igy a szoveg ala kerul. */}
              <div className="ftr-nw-content">
                <div className="ftr-nw-form">
                  <a
                     onClick={()=>handleClickPhone('06704093379')}
                    href="tel:06704093379" className="ftr-nw-subcribe-btn mr-[10px] rounded-[5px]">+36 70 409 3379</a>
                  <a
                     onClick={()=>handleClickPhone('06706251650')}
                    href="tel:06706251650" className="ftr-nw-subcribe-btn rounded-[5px]">+36 70 625 1650</a>
                </div>
                <div className="ftr-nw-title">
                  7/24 - Hívjon bizalommal!
                </div>
              </div>
              <div className="ftr-nw-img">
                <img src={publicUrlFor("/assets/images/teleport-munkatars.png")}
                     alt="Teleport munkatárs"/>
              </div>
            </div>
          </div>
        </div>
        {/* NEWS LETTER SECTION END */}


        <div className="ftr-bg">
          {/* FOOTER BLOCKES START */}
          <div className="footer-top">
            <div className="container">
              <div className="row">

                <div className="col-lg-4 col-md-6">

                  <div className="widget widget_about">
                    <div className="logo-footer clearfix">
                      <NavLink to="/">
                        {/* <img src={publicUrlFor("/assets/images/logo-dark.png")} alt="#" />*/}
                        <div className={"flex flex-column text-center"}>
                          <img className={'h-[40px] object-contain'}
                               src={publicUrlFor("/assets/images/icons/truck.png")} alt="truck"/>
                          <div className={'text-[30px] text-bold leading-[28px] text-[#fefefe]'}>
                            TELEPORT
                          </div>
                          <div
                            className={'text-[9px] bg-gradient-to-r from-[#efaf4d] to-[#eae244] bg-clip-text text-transparent'}>
                            Költöztetés - Bútorszállítás - Lomtalanítás
                          </div>
                        </div>
                      </NavLink>
                    </div>
                    <div className="ftr-slogan">{slogan}</div>
                    <p>KÖLTÖZTETÉS STRESSZMENTESEN
                    </p>
                    {referral.active && (
                      <p className="mt-[10px]">
                        Ajánljon minket ismerőseinek! Sikeres ajánlás után <b>{referral.amount}</b> jár Önnek.
                      </p>
                    )}
                    <ul className="social-icons">
                      <li><a target={'_blank'} href="https://www.facebook.com/profile.php?id=61579026941787"
                             className="fa fa-facebook"> </a></li>
                    </ul>
                  </div>

                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="widget widget_services ftr-list-center">
                    <h3 className="widget-title">Linkek</h3>
                    <ul>
                      <li>
                        <Link
                          activeClass="active"
                          to="about-us"
                          spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          className={'cursor-pointer'}
                        >
                          Rólunk
                        </Link>
                      </li>

                      <li>

                        <Link
                          activeClass="active"
                          to="services"
                          spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          className={'cursor-pointer'}
                        >
                          Szolgáltatásaink
                        </Link>
                      </li>
                      <li>
                        <Link
                          activeClass="active"
                          to="prices"
                          spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          className={'cursor-pointer'}
                        >
                          Áraink
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="widget widget_services ftr-list-center">
                    <h3 className="widget-title">Szolgáltatások</h3>
                    <ul>
                      <li><a>Költöztetés</a></li>
                      <li><a>Bútorszállítás</a></li>
                      <li><a>Lomtalanítás</a></li>
                      <li><a>TeherTaxi</a></li>
                      <li><a>Áruszállítás</a></li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* FOOTER COPYRIGHT */}

          <div className="footer-bottom">
            <div className="container">
              <div className="footer-bottom-info">

                <div className="footer-copy-right">
                  <span className="copyrights-text">

                    <div className={'flex items-center gap-1 justify-center'}>
                      <span>Copyright © {date} </span>
                      <a>
                        Teleport Költöztetés
                      </a>
                    </div>
                    <div className={"text-center"}>
                      <span>
                        Minden jog fenntartva.
                      </span>
                    </div>
                    <div className={"text-center mt-1"}>
                      <button
                        type="button"
                        onClick={resetConsent}
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: 0,
                          textDecoration: 'underline',
                          color: 'inherit',
                          cursor: 'pointer'
                        }}
                      >
                        Süti beállítások
                      </button>
                    </div>

                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>

      </footer>
    </>
  )
}